export default __webpack_public_path__ + "static/media/gallery 9.ad71757b.png";